/* import __COLOCATED_TEMPLATE__ from './sh-error.hbs'; */
import Component from '@glimmer/component';

/**
 * Available error styles for the text.
 * @type {Object}
 */
export const SH_ERROR__ERROR_STYLE = {
  DEFAULT: 'default',
  SMALL: 'small',
};

/**
 * This component will show the error in a given array using `errors` + `errorKey`
 * OR an error represented by a single argument `error`
 */
class ShError extends Component {
  get error() {
    return this.args.errors
      ? this.args.errors[this.args.errorKey]
      : this.args.error;
  }

  get isSmallErrorStyle() {
    return this.args.errorStyle === SH_ERROR__ERROR_STYLE.SMALL;
  }
}

export default ShError;
